/**
 * Performance monitoring utility for measuring API request performance
 */

class PerformanceMonitor {
    constructor() {
        this.metrics = {
            apiCalls: 0,
            batchedCalls: 0,
            individualCalls: 0,
            totalTime: 0,
            operations: []
        };
    }

    startOperation(type, id) {
        const operationId = `${type}_${id}_${Date.now()}`;
        this.metrics.operations.push({
            id: operationId,
            type,
            startTime: performance.now(),
            endTime: null
        });
        return operationId;
    }

    endOperation(operationId, success = true) {
        const operation = this.metrics.operations.find(op => op.id === operationId);
        if (operation) {
            operation.endTime = performance.now();
            operation.duration = operation.endTime - operation.startTime;
            operation.success = success;
        }
    }

    incrementApiCall(type = 'individual') {
        this.metrics.apiCalls++;
        if (type === 'batch') {
            this.metrics.batchedCalls++;
        } else {
            this.metrics.individualCalls++;
        }
    }

    getMetrics() {
        const completedOps = this.metrics.operations.filter(op => op.endTime);
        const avgDuration = completedOps.length > 0 
            ? completedOps.reduce((sum, op) => sum + op.duration, 0) / completedOps.length 
            : 0;

        return {
            ...this.metrics,
            averageDuration: avgDuration,
            successRate: completedOps.length > 0 
                ? completedOps.filter(op => op.success).length / completedOps.length 
                : 0
        };
    }

    reset() {
        this.metrics = {
            apiCalls: 0,
            batchedCalls: 0,
            individualCalls: 0,
            totalTime: 0,
            operations: []
        };
    }

    logReport() {
        const metrics = this.getMetrics();
        console.group('📊 Performance Report');
        console.log('Total API Calls:', metrics.apiCalls);
        console.log('Batched Calls:', metrics.batchedCalls);
        console.log('Individual Calls:', metrics.individualCalls);
        console.log('Average Duration:', `${metrics.averageDuration.toFixed(2)}ms`);
        console.log('Success Rate:', `${(metrics.successRate * 100).toFixed(1)}%`);
        console.log('Batch Efficiency:', metrics.batchedCalls > 0 ? 
            `${((metrics.individualCalls / metrics.batchedCalls) || 0).toFixed(1)}:1` : 'N/A');
        console.groupEnd();
    }
}

// Create singleton instance
const performanceMonitor = new PerformanceMonitor();

export default performanceMonitor;